<template>
  <v-container class="pt-0 pb-5">
    <v-row>
      <v-col>
        <div class="pa-2 rounded elevation-1 bg-white">
          <SportipsButton backButton chevronLeft>Retour</SportipsButton>
          <div class="text-h6 font-weight-bold mt-3 mb-2">Exporter les équipes</div>


          <v-progress-linear v-if="loading" indeterminate color="primary-dark" class="mb-4" />

          <v-alert v-if="loadError" type="error" variant="tonal" class="mb-4" density="compact">
            Impossible de charger la liste des groupes.
          </v-alert>

          <template v-else-if="!loading">
            <div>Sur la liste PDF de l'équipe, les participants seront triés par :</div>
            <v-select v-model="sortBy" label="Trier par" :items="['Nom', 'Dossard', 'Parcours', 'Date inscription']"
              density="compact" variant="filled" class="mb-4" hide-details />
            <v-text-field v-model="search" label="Rechercher un groupe ou une équipe" prepend-inner-icon="mdi-magnify"
              clearable density="compact" variant="filled" class="mb-4" hide-details />



            <div v-if="groupes.length === 0" class="text-body-1 text-medium-emphasis">
              Aucun groupe ou équipe avec des inscrits pour l'instant.
            </div>

            <div v-else-if="filteredGroupes.length === 0" class="text-body-1 text-medium-emphasis">
              Aucun groupe ne correspond à votre recherche.
            </div>



            <v-table v-else density="compact">
              <thead>
                <tr>
                  <th class="text-left">Nom de l'équipe</th>
                  <th class="text-right">Nb Inscrits</th>
                  <th class="text-right">Export</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="groupe in filteredGroupes" :key="groupe.nom_groupe">
                  <td class="font-weight-medium">{{ groupe.nom_groupe }}</td>
                  <td class="text-right">{{ groupe.nb_inscrits }}</td>
                  <td class="text-right">
                    <v-btn color="primary-dark" density="compact" prepend-icon="mdi-file-pdf-box"
                      :loading="exportLoadingNom === groupe.nom_groupe" @click="exportPdf(groupe)">
                      Télécharger
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";

export default {
  data() {
    return {
      groupes: [],
      loading: false,
      loadError: false,
      search: "",
      sortBy: "Nom",
      exportLoadingNom: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    filteredGroupes() {
      const q = (this.search ?? "").trim().toLowerCase();
      let list = this.groupes;
      if (q) {
        list = list.filter((g) => (g.nom_groupe ?? "").toLowerCase().includes(q));
      }
      return [...list].sort((a, b) =>
        (a.nom_groupe ?? "").localeCompare(b.nom_groupe ?? "", "fr", { sensitivity: "base" })
      );
    },
  },
  created() {
    this.fetchGroupes();
  },
  methods: {
    async fetchGroupes() {
      this.loading = true;
      this.loadError = false;
      const data = await AdminService.getNfl26Equipes(this.mainStore.module.id);
      this.loading = false;
      if (!data || !Array.isArray(data.groupes)) {
        this.loadError = !data;
        this.groupes = [];
        return;
      }
      this.groupes = data.groupes;
    },
    slugFilename(nom) {
      const slug = (nom ?? "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9_-]+/g, "_")
        .replace(/^_+|_+$/g, "");
      return slug || "equipe";
    },
    inscriptionsForExport(groupe) {
      if (!Array.isArray(groupe?.inscriptions)) return [];
      return groupe.inscriptions
        .filter((ins) => ins.id_inscription != null && ins.id_inscription !== "")
        .map((ins) => ({
          id_inscription: ins.id_inscription,
          nom: ins.nom ?? "",
          prenom: ins.prenom ?? "",
          dossard: ins.dossard ?? "",
          course: ins.course ?? "",
          via_lien_groupe: !!ins.via_lien_groupe,
        }));
    },
    async exportPdf(groupe) {
      const inscriptions = this.inscriptionsForExport(groupe);
      if (inscriptions.length === 0) {
        this.mainStore.notification.send("Aucun inscrit à exporter pour ce groupe.", "error");
        return;
      }
      this.exportLoadingNom = groupe.nom_groupe;
      const blob = await AdminService.exportNfl26EquipePdf({
        id_module: this.mainStore.module.id,
        nom_groupe: groupe.nom_groupe,
        inscriptions,
        sort_by: this.sortBy,
      });
      this.exportLoadingNom = null;
      if (!blob) {
        this.mainStore.notification.send("Impossible de générer le PDF.", "error");
        return;
      }
      const url = window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      const date = new Date().toISOString().split("T")[0];
      link.setAttribute("download", `Groupe_${this.slugFilename(groupe.nom_groupe)}_${date}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>
